import axios from 'axios'
import apiResponse from '@/store/apiResponse'
import { tenantId, wartApi } from '@/config'


export default {
    // 查询串码
    getByImei({ state }, { imei }) {
        return axios
            .post(wartApi + '/imei/getByImei', {
                imei,
                tenantId
            })

        .then(response => {
                if (response.data.status === 1) {
                    return apiResponse(true, response.data.data, response.data.msg)
                } else {
                    return apiResponse(false, response.data.data, response.data.msg)
                }

            })
            .catch(err => {
                return apiResponse(false, null, "服务器异常")
            })
    },
    // 获取视频
    tenantGet({ state }, {}) {
        return axios
            .post(wartApi + '/tenant/get', {
                id: tenantId
            })
            .then(response => {
                if (response.data.status === 1) {
                    return apiResponse(true, response.data.data, response.data.msg)
                } else {
                    return apiResponse(false, response.data.data, response.data.msg)
                }

            })
            .catch(err => {
                return apiResponse(false, null, "服务器异常")
            })
    },
}


// WEBPACK FOOTER //
// ./src/store/actions/index.js